export default "__VITE_ASSET__89cf198f__"